package org.zest.insan_360_website.pages.user.main_layout

import org.zest.insan_360_website.data.localized

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.icons.fa.FaBrain
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text
import org.zest.insan_360_website.components.layouts.*
import org.zest.insan_360_website.components.widgets.*
import org.zest.insan_360_website.data.LanguageSettings
import org.zest.insan_360_website.data.page_states.AuthState
import org.zest.insan_360_website.data.page_states.CreditState
import org.zest.insan_360_website.data.page_states.CreditState.activeCreditSession
import org.zest.insan_360_website.data.page_states.CreditState.creditState
import org.zest.insan_360_website.data.page_states.UserPreferences
import org.zest.insan_360_website.data.page_states.dashboard.MainDashPageState.handleStartAssessmentClick
import org.zest.insan_360_website.data.page_states.dashboard.MainDashPageState.personalCreditHistory
import org.zest.insan_360_website.model.CreditHistory
import org.zest.insan_360_website.model.CreditStatus
import org.zest.insan_360_website.model.UserRole
import org.zest.insan_360_website.pages.user.contentBackgroundIconStyle
import org.zest.insan_360_website.utils.SessionTimerText
import org.zest.insan_360_website.utils.SessionTimerUtils
import org.zest.insan_360_website.utils.buyCredit
import org.zest.insan_360_website.utils.formatToReadableDateJS

val studMainDashContentLayout = CssStyle {
    base {
        Modifier
            .grid {
                rows { repeat(2) { size(1.fr) } }
            }
    }
    Breakpoint.SM {
        Modifier
            .grid {
                rows { size(1.fr) }
                columns { repeat(2) { size(1.fr) } }
            }
    }
    Breakpoint.XL {
        Modifier
            .grid {
                rows { size(1.fr) }
                columns { repeat(3) { size(1.fr) } }
            }
    }
}

@Composable
fun StudentLayout(ctx: PageContext) {
    PageContentBaseCol {
        Div(
            studMainDashContentLayout.toModifier()
                .gap(1.cssRem)
                .fillMaxWidth()
                .toAttrs()
        ) {
            TestPromptContainer(ctx)
            CreditStateContainer()
        }
        CreditHistoryList()
    }
}

@OptIn(DelicateApi::class)
@Composable
private fun CreditHistoryList() {
    val breakpoint = rememberBreakpoint()

    PageContentContainer(
        Modifier
            .fillMaxSize()
            .padding(0.px)
            .border { width(0.px) }
            .flex(1)
    ) {
        FlushedListContainer(
            1,
            {
                SpanText(
                    userDashWordLibrary.credit_purchase_record.localized,
                    Modifier.fontWeight(FontWeight.Bold).fontSize(1.5.cssRem),
                )
            }
        ) {
            personalCreditHistory?.credits?.forEachIndexed { index, history ->
                FlushedListRowWrapper(index = index) {
                    if (breakpoint >= Breakpoint.MD) {
                        CreditHistoryRowMD(history)
                    } else {
                        CreditHistoryRowBase(history)
                    }
                }
            }
        }
    }
}

@Composable
private fun CreditHistoryRowBase(history: CreditHistory) {
    Row(
        Modifier
            .fillMaxSize()
            .gap(0.5.cssRem)
    ) {
        Column(
            Modifier
                .fillMaxWidth()
                .padding(topBottom = 0.5.cssRem)
                .gap(1.cssRem)
        ) {
            Row(
                Modifier.fillMaxWidth().justifyContent(JustifyContent.SpaceBetween),
                verticalAlignment = Alignment.Top
            ) {
                Column {
                    CopyableIdText(history.paymentId, "N/A")
                    CreditHistoryLabel(
                        userDashWordLibrary.id_transaction.localized
                    )
                }
                CreditHistoryBadge(history.status)
            }
            Div(
                Modifier
                    .fillMaxWidth()
                    .display(DisplayStyle.Grid)
                    .grid {
                        columns { repeat(2) { size(1.fr) } }
                    }
                    .gap(0.75.cssRem)
                    .toAttrs()
            ) {

                Column {
                    CopyableIdText(history.referenceId, "N/A")
                    CreditHistoryLabel(
                        userDashWordLibrary.id_toyyib.localized
                    )
                }

                Column(Modifier.gap(0.1.cssRem)) {
                    CopyableIdText(
                        history.creditId,
                        userDashWordLibrary.no_credit.localized
                    )
                    CreditHistoryLabel(
                        userDashWordLibrary.id_credit.localized
                    )
                }

                Column {
                    SpanText(
                        formatToReadableDateJS(history.purchaseAt),
                        Modifier.fontWeight(FontWeight.Medium).fontSize(0.875.cssRem)
                    )
                    CreditHistoryLabel(
                        userDashWordLibrary.time_transaction.localized
                    )
                }

                Column {
                    val usedAtString = if (history.usedAt != null) {
                        formatToReadableDateJS(history.usedAt)
                    } else {
                        userDashWordLibrary.not_used.localized
                    }
                    SpanText(
                        usedAtString,
                        Modifier.fontWeight(FontWeight.Medium).fontSize(0.875.cssRem)
                    )
                    CreditHistoryLabel(
                        userDashWordLibrary.time_used.localized
                    )
                }
            }
        }
    }
}

@Composable
private fun CreditHistoryRowMD(history: CreditHistory) {
    Div(
        Modifier
            .fillMaxWidth()
            .gap(0.5.cssRem)
            .display(DisplayStyle.Grid)
            .grid {
                columns {
                    size(2.fr)
                    size(2.fr)
                    size(2.fr)
                    size(3.fr)
                    size(3.fr)
                    size(3.fr)

                }
            }
            .toAttrs()
    ) {
        Column(
            horizontalAlignment = Alignment.Start,
            verticalArrangement = Arrangement.Center
        ) {
            CopyableIdText(id = history.paymentId)
            CreditHistoryLabel(
                userDashWordLibrary.id_transaction.localized
            )
        }
        Column(
            horizontalAlignment = Alignment.Start,
            verticalArrangement = Arrangement.Center
        ) {
            CopyableIdText(history.referenceId)
            CreditHistoryLabel(
                userDashWordLibrary.id_toyyib.localized
            )
        }
        Column(
            horizontalAlignment = Alignment.Start,
            verticalArrangement = Arrangement.Center
        ) {
            CopyableIdText(
                id = history.creditId,
                fallbackText = userDashWordLibrary.no_credit.localized
            )
            CreditHistoryLabel(
                userDashWordLibrary.id_credit.localized
            )
        }
        Box(contentAlignment = Alignment.CenterEnd) {
            CreditHistoryBadge(history.status)
        }
        Column(
            horizontalAlignment = Alignment.End,
            verticalArrangement = Arrangement.Center
        ) {
            SpanText(formatToReadableDateJS(history.purchaseAt), Modifier.fontSize(0.875.cssRem))
            CreditHistoryLabel(
                userDashWordLibrary.time_transaction.localized
            )
        }
        Column(
            horizontalAlignment = Alignment.End,
            verticalArrangement = Arrangement.Center
        ) {
            val usedAtString =
                if (history.usedAt != null) formatToReadableDateJS(history.usedAt)
                else userDashWordLibrary.not_used.localized
            SpanText(usedAtString, Modifier.fontSize(0.875.cssRem))
            CreditHistoryLabel(
                userDashWordLibrary.time_used.localized
            )
        }
    }
}

@OptIn(DelicateApi::class)
@Composable
private fun CreditStateContainer() {
    val modal = LocalModal.current
    val toast = LocalToast.current
    PageContentContainer(
        Modifier
            .fillMaxSize()
            .position(Position.Relative)
            .overflow(Overflow.Clip)
            .flexDirection(FlexDirection.Column)
            .justifyContent(JustifyContent.SpaceBetween)
            .gap(0.5.cssRem)
            .then(containerShadowStyle.toModifier())
    ) {
        Column {
            SpanText(
                userDashWordLibrary.current_credit_status.localized,
                Modifier
                    .padding(leftRight = 0.5.cssRem, top = 0.25.cssRem)
                    .margin(bottom = 0.25.cssRem)
                    .fontSize(1.cssRem)
                    .fontWeight(FontWeight.Bold)
                    .color(userPageSecondaryTextColor)
                    .userSelect(UserSelect.None)
            )
            SpanText(
                if (CreditState.isLoading) userDashWordLibrary.loading.localized
                else userDashWordLibrary.credit_state[creditState]?.get(UserPreferences.language)
                    ?: when (creditState) {
                        CreditStatus.ACTIVE -> "Available"
                        CreditStatus.IN_PROGRESS -> "In Progress"
                        CreditStatus.EXPIRED -> "Expired"
                        CreditStatus.USED -> "Used"
                        null -> "Inactive"
                    },
                Modifier
                    .padding(leftRight = 0.5.cssRem)
                    .fontWeight(FontWeight.Bolder)
                    .fontSize(2.25.cssRem)
                    .color(userPagePrimaryTextColor)
                    .lineHeight(0.75)
                    .userSelect(UserSelect.None)
            )
        }
        Row(
            Modifier
                .fillMaxWidth()
                .padding(bottom = 0.25.cssRem, right = 0.25.cssRem),
            horizontalArrangement = Arrangement.End
        ) {
            Box(
                Modifier
                    .onClick {
                        var toastText = ""
                        when (creditState) {
                            CreditStatus.ACTIVE ->
                                toastText = userDashWordLibrary.only_one_credit.localized

                            CreditStatus.IN_PROGRESS ->
                                toastText = userDashWordLibrary.please_finish_test.localized

                            null -> return@onClick
                            else -> {
                                if (AuthState.orgId == null) {
                                    modal.show {
                                        BuyCreditModal()
                                    }
                                } else {
                                    toastText = userDashWordLibrary.user_with_org_not_allowed.localized
                                }
                            }
                        }
                        if (toastText.isNotEmpty()) toast.show(toastText)
                    }
                    .thenIf(creditState == CreditStatus.USED || creditState == CreditStatus.EXPIRED) {
                        contentButtonStyle.toModifier()
                    }
                    .thenIf(creditState == CreditStatus.ACTIVE || creditState == CreditStatus.IN_PROGRESS) {
                        disabledContentButtonStyle.toModifier()
                    }
            ) {
                SpanText(
                    userDashWordLibrary.buy_credit.localized,
                    modifier = Modifier
                        .then(contentButtonTextStyle.toModifier())
                )
            }
        }
    }
}

@OptIn(DelicateApi::class)
@Composable
private fun TestPromptContainer(ctx: PageContext) {
    val toast = LocalToast.current
    val scope = rememberCoroutineScope()
    val timerState = SessionTimerUtils.rememberSessionTimerState(activeCreditSession)

    PageContentContainer(
        Modifier
            .fillMaxSize()
            .position(Position.Relative)
            .overflow(Overflow.Clip)
            .flexDirection(FlexDirection.Column)
            .justifyContent(JustifyContent.SpaceBetween)
            .then(containerShadowStyle.toModifier())
    ) {
        SpanText(
            userDashWordLibrary.personality_test.localized,
            Modifier
                .padding(0.5.cssRem)
                .fontSize(2.25.cssRem)
                .fontWeight(FontWeight.Bold)
                .lineHeight(0.75)
                .color(userPageSecondaryTextColor)
                .userSelect(UserSelect.None)
        )
        Row(
            Modifier
                .fillMaxWidth()
                .padding(leftRight = 0.25.cssRem, bottom = 0.25.cssRem)
                .justifyContent(JustifyContent.FlexEnd),
        ) {
            Box(
                BaseButtonModifier
                    .position(Position.Absolute)
                    .left(0.5.cssRem)
                    .bottom(0.5.cssRem)
                    .zIndex(1)
                    .cursor(Cursor.Default),
                contentAlignment = Alignment.Center
            ) {
                if (activeCreditSession.hasActiveSession && activeCreditSession.sessionExpiresAt != null) {
                    SessionTimerText(
                        timerState,
                        Modifier
                            .fontSize(1.cssRem)
                            .fontWeight(FontWeight.SemiBold)
                            .color(userPageSecondaryTextColor)
                    )
                }
            }
            Box(
                Modifier
                    .thenIf(
                        creditState != CreditStatus.ACTIVE &&
                                creditState != CreditStatus.IN_PROGRESS
                    ) {
                        disabledContentButtonStyle.toModifier()
                            .onClick {
                                toast.show(
                                    userDashWordLibrary.not_enough_credit.localized,
                                    ToastType.ERROR
                                )
                            }
                    }
                    .thenIf(
                        creditState == CreditStatus.ACTIVE ||
                                creditState == CreditStatus.IN_PROGRESS
                    ) {
                        contentButtonStyle.toModifier()
                            .onClick {
                                scope.launch {
                                    handleStartAssessmentClick(toast, ctx)
                                }
                            }
                    }
            ) {
                SpanText(
                    if (creditState == CreditStatus.IN_PROGRESS)
                        userDashWordLibrary.continue_test.localized
                    else
                        userDashWordLibrary.begin_test.localized,
                    modifier = Modifier
                        .then(contentButtonTextStyle.toModifier())
                )
            }
        }

        Box(
            Modifier.width(Width.FitContent).height(Height.FitContent)
                .then(contentBackgroundIconStyle.toModifier())
        ) {
            FaBrain(
                Modifier
                    .color(userPageColor.copyf(alpha = 0.25f).darkened(0.75f))
                    .rotate(15.deg),
                size = IconSize.X7
            )
        }
    }
}

@OptIn(DelicateApi::class)
@Composable
fun BuyCreditModal() {
    var isProcessing by remember { mutableStateOf(false) }
    val scope = rememberCoroutineScope()
    val breakpoint = rememberBreakpoint()
    val toast = LocalToast.current
    val modal = LocalModal.current
    val isMobile = breakpoint < Breakpoint.SM


    Column(
        Modifier
            .padding(if (isMobile) 0.5.cssRem else 1.5.cssRem)
            .gap(1.5.cssRem),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Column(
            Modifier.fillMaxWidth().gap(0.5.cssRem),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                LanguageSettings.UserDashboardPage.PaymentModal.title.localized,
                Modifier
                    .fontWeight(FontWeight.Bold)
                    .fontSize(1.5.cssRem)
                    .color(userPagePrimaryTextColor)
                    .textAlign(TextAlign.Center)
            )
            SpanText(
                LanguageSettings.UserDashboardPage.PaymentModal.text.localized,
                Modifier
                    .fontSize(0.875.cssRem)
                    .fontWeight(FontWeight.Medium)
                    .color(userPageSecondaryTextColor)
                    .textAlign(TextAlign.Center)
            )
        }
        Button(
            enabled = !isProcessing,
            onClick = {
                if (isProcessing) return@Button
                buyCredit(toast, modal, scope) { processing ->
                    isProcessing = processing
                }
            },
            modifier = Modifier
                .fillMaxWidth()
                .minHeight(3.cssRem)
                .fontSize(1.cssRem)
                .fontWeight(FontWeight.Bold)
        ) {
            Text(
                if (isProcessing) LanguageSettings.UserDashboardPage.PaymentModal.connecting.localized
                else LanguageSettings.UserDashboardPage.PaymentModal.pay_with.localized
            )
        }
    }
}

@Composable
private fun CreditHistoryLabel(text: String, textAlign: TextAlign = TextAlign.Start) {
    SpanText(
        text,
        Modifier
            .fontSize(0.75.cssRem)
            .fontWeight(FontWeight.Medium)
            .color(userPageSecondaryTextColor)
            .textAlign(textAlign)
    )
}

@Composable
private fun CreditHistoryBadge(status: String) {
    val (statusColor, displayText) = when (status) {
        "PAID" -> Pair(
            Color.rgb(0x16a34a),
            userDashWordLibrary.creditHistoryState["PAID"]?.get(UserPreferences.language) ?: "PAID"
        )

        "ACTIVE" -> Pair(
            Color.rgb(0x16a34a),
            userDashWordLibrary.creditHistoryState["ACTIVE"]?.get(UserPreferences.language) ?: "ACTIVE"
        )

//        "PENDING" -> Pair(
//            Color.rgb(0xd97706),
//            userDashWordLibrary.creditHistoryState["PENDING"]?.get(UserPreferences.language) ?: "PENDING"
//        )

        "IN_PROGRESS" -> Pair(
            Color.rgb(0xca8a04),
            userDashWordLibrary.creditHistoryState["IN_PROGRESS"]?.get(UserPreferences.language) ?: "IN PROGRESS"
        )

        "FAILED", "PENDING" -> Pair(
            Color.rgb(0xc0ca80),
            userDashWordLibrary.creditHistoryState["FAILED"]?.get(UserPreferences.language) ?: "FAILED"
        )

        "EXPIRED" -> Pair(
            Color.rgb(0xdc2626),
            userDashWordLibrary.creditHistoryState["EXPIRED"]?.get(UserPreferences.language) ?: "EXPIRED"
        )

        "USED" -> Pair(
            Color.rgb(0x6b7280),
            userDashWordLibrary.creditHistoryState["USED"]?.get(UserPreferences.language) ?: "USED"
        )

        else -> Pair(
            Color.rgb(0x6b7280),
            userDashWordLibrary.creditHistoryState["ERROR"]?.get(UserPreferences.language) ?: "ERROR"
        )
    }

    StatusBadge(
        text = displayText,
        color = statusColor,
        modifier = Modifier.userSelect(UserSelect.None)
    )
}